import { Stack } from '@mui/material';
import { Link } from 'react-router-dom';

import Button from '../../../../components/styledComponents/Button';

interface SharedButtonsProps {
  disabled: boolean;
  onClick?: () => void;
}

const SharedButtons = ({ disabled, ...props }: SharedButtonsProps) => (
  <Stack
    justifyContent="flex-end"
    direction={{ mobile: 'column', tablet: 'row' }}
    spacing={{ mobile: 1, tablet: 2 }}
    sx={{ mt: { mobile: 2, tablet: 'auto' } }}
  >
    <Button
      component={Link}
      replace
      to="/bills"
      variant="outlined"
      color="inherit"
      sx={{
        width: { mobile: 1, tablet: 'auto' },
        '&:hover': {
          borderRadius: 1,
          borderWidth: 2,
        },
      }}
      data-testid="paymentAmountDialogCancelButton"
    >
      Cancel
    </Button>
    <Button
      sx={{ width: { mobile: 1, tablet: 'auto' } }}
      type="submit"
      variant="contained"
      data-testid="paymentAmountDialogDoneButton"
      disabled={disabled}
      {...props}
    >
      Continue
    </Button>
  </Stack>
);

export default SharedButtons;
